"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextInputFormField = void 0;

var _react = _interopRequireDefault(require("react"));

var _control = require("@waglabs/control");

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var TextInputFormField = function TextInputFormField(_ref) {
  var containerProps = _ref.containerProps,
      errorMessageProps = _ref.errorMessageProps,
      hasErrorMessage = _ref.hasErrorMessage,
      isFirst = _ref.isFirst,
      label = _ref.label,
      renderComponent = _ref.renderComponent,
      type = _ref.type,
      propsOnBlur = _ref.onBlur,
      propsOnChange = _ref.onChange,
      propsOnFocus = _ref.onFocus,
      props = _objectWithoutPropertiesLoose(_ref, ["containerProps", "errorMessageProps", "hasErrorMessage", "isFirst", "label", "renderComponent", "type", "onBlur", "onChange", "onFocus"]);

  return _react.default.createElement(_.FormField, _extends({}, props, {
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          name = _ref2$field.name,
          formikOnBlur = _ref2$field.onBlur,
          formikOnChange = _ref2$field.onChange,
          formikOnFocus = _ref2$field.onFocus,
          value = _ref2$field.value,
          _ref2$form = _ref2.form,
          touched = _ref2$form.touched,
          errors = _ref2$form.errors;
      var isTouched = touched[name];
      var isValid = !errors[name];
      var errorMessage = errors[name];

      var onBlur = function onBlur() {
        if (formikOnBlur) formikOnBlur.apply(void 0, arguments);
        if (propsOnBlur) propsOnBlur.apply(void 0, arguments);
      };

      var onFocus = function onFocus() {
        if (formikOnFocus) formikOnFocus.apply(void 0, arguments);
        if (propsOnFocus) propsOnBlur.apply(void 0, arguments);
      };

      var onChange = function onChange() {
        if (formikOnChange) formikOnChange.apply(void 0, arguments);
        if (propsOnChange) propsOnChange.apply(void 0, arguments);
      };

      return _react.default.createElement(_.FormFieldContainer, _extends({
        isFirst: isFirst
      }, containerProps), renderComponent && renderComponent(Object.assign({
        containerProps: containerProps,
        isTouched: isTouched,
        isValid: isValid,
        label: label,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        type: type,
        value: value
      }, props)), !renderComponent && _react.default.createElement(_control.TextInputField, _extends({
        containerProps: containerProps,
        isTouched: isTouched,
        isValid: isValid,
        label: label,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        type: type,
        value: value
      }, props)), hasErrorMessage && isTouched && !isValid && errorMessage && _react.default.createElement(_.FormFieldErrorMessage, errorMessageProps, errorMessage));
    }
  }));
};

exports.TextInputFormField = TextInputFormField;
TextInputFormField.defaultProps = {
  hasErrorMessage: true,
  isFirst: false,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {}
};
var _default = TextInputFormField;
exports.default = _default;